import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import Strings from '../../../Strings';
import { actions } from '../../SuperUser/Patients/redux/actions';

function PatientsWithMandatoryTasksMissing(props) {
  const { getData, onClick, refreshTimestamp, orgIds } = props;
  const [data, setData] = React.useState('-');

  React.useEffect(() => {
    getData((orgIds && orgIds.length > 0) ? orgIds : undefined).then(resp => {
      if (resp?.response?.pagination?.totalRecords !== undefined) {
        setData(resp.response.pagination.totalRecords);
      }
    });
  }, [refreshTimestamp, orgIds]);

  return (
    <div className="boxWithVl-box">
      <div className="boxWithVl-valueBox black">{data}</div>
      <div
        onClick={() => onClick(`/cap-patients/list?filters=["billingAlerts:missing_mandatory_tasks"]`)}
        className="boxWithVl-labelBox clickable"
      >
        {Strings.widgets.patientsWithMandatoryTasksMissing}
      </div>
    </div>
  )
}

PatientsWithMandatoryTasksMissing.widgetId = 'PatientsWithMandatoryTasksMissingWidget';

PatientsWithMandatoryTasksMissing.propTypes = {
  getData: PropTypes.func,
  onClick: PropTypes.func,
  orgId: PropTypes.string,
  refreshTimestamp: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getData: orgId => dispatch(actions.queryPatients({offset: 0, status: 'activated', alert: 'missing_mandatory_tasks', limit: 1, orgId})),
  onClick: path => dispatch(push(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsWithMandatoryTasksMissing);
